/* Falbana: widok produktu (karuzele zdjęć per kolor, wybór koloru, mała torba do kompletu).
   Bez zależności. Działa też po przeładowaniu sekcji w edytorze motywu. */
(() => {
  'use strict';

  const T = window.theme || {};
  const $ = (selector, scope = document) => scope.querySelector(selector);
  const $$ = (selector, scope = document) => Array.from(scope.querySelectorAll(selector));

  const formatMoney = (cents) => {
    try {
      return new Intl.NumberFormat(T.locale || undefined, { style: 'currency', currency: T.currency || 'PLN' }).format(cents / 100);
    } catch (error) {
      return (cents / 100).toFixed(2);
    }
  };

  const readJSON = (el) => {
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return [];
    }
  };

  class ProductView {
    constructor(root) {
      this.root = root;
      this.variants = readJSON($('[data-pdp-json]', root));
      this.addonVariants = readJSON($('[data-pdp-addon-json]', root));
      this.colorPos = Number(root.dataset.colorPos) || 0;
      this.addonColorPos = Number(root.dataset.addonColorPos) || 0;
      this.noUrlUpdate = root.hasAttribute('data-no-url-update');
      this.addonOn = false;
      this.drag = null;

      this.idInput = $('[data-variant-id]', root);
      this.addonInput = $('[data-pdp-addon-id]', root);
      this.priceEl = $('[data-pdp-price]', root);
      this.cta = $('[data-add-to-cart]', root);
      this.addonEl = $('[data-pdp-addon]', root);
      this.addonToggle = $('[data-pdp-addon-toggle]', root);

      this.bind();
      this.render(false);
    }

    selection() {
      const selected = [];
      $$('[data-pdp-option]', this.root).forEach((button) => {
        if (button.getAttribute('aria-pressed') === 'true') selected[Number(button.dataset.pdpOption) - 1] = button.dataset.value;
      });
      return selected;
    }

    variant() {
      const selected = this.selection();
      return this.variants.find((v) => v.options.every((value, i) => value === selected[i]));
    }

    addonVariant() {
      if (!this.addonVariants.length) return null;
      const selected = this.selection();
      if (this.addonColorPos > 0 && this.colorPos > 0) {
        const color = selected[this.colorPos - 1];
        return this.addonVariants.find((a) => a.options[this.addonColorPos - 1] === color && a.available) || null;
      }
      return this.addonVariants.find((a) => a.available) || null;
    }

    gallery() {
      return $('.gallery:not(.is-hidden)', this.root);
    }

    /* ---------- Zdarzenia ---------- */

    bind() {
      const root = this.root;

      root.addEventListener('click', (event) => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;

        const option = target.closest('[data-pdp-option]');
        if (option) return this.pickOption(option);

        if (target.closest('[data-pdp-addon-toggle]')) {
          this.addonOn = !this.addonOn;
          return this.render(false);
        }

        const dot = target.closest('[data-gallery-dot]');
        if (dot) return this.goTo(Number(dot.dataset.galleryDot));

        if (target.closest('[data-gallery-prev]')) return this.step(-1);
        if (target.closest('[data-gallery-next]')) return this.step(1);
      });

      root.addEventListener(
        'scroll',
        (event) => {
          const el = event.target;
          if (el instanceof Element && el.matches('[data-gallery-track]')) this.syncDots(el);
        },
        true
      );

      root.addEventListener('keydown', (event) => {
        const track = event.target instanceof Element ? event.target.closest('[data-gallery-track]') : null;
        if (!track) return;
        if (event.key === 'ArrowLeft') { event.preventDefault(); this.step(-1); }
        if (event.key === 'ArrowRight') { event.preventDefault(); this.step(1); }
      });

      // Przeciąganie myszką (na telefonie działa zwykłe przewijanie z przyciąganiem).
      root.addEventListener('mousedown', (event) => {
        const track = event.target instanceof Element ? event.target.closest('[data-gallery-track]') : null;
        if (!track || event.button !== 0) return;
        this.drag = { track, x: event.clientX, left: track.scrollLeft };
        track.style.scrollSnapType = 'none';
        track.style.cursor = 'grabbing';
      });
      root.addEventListener('mousemove', (event) => {
        if (!this.drag) return;
        this.drag.track.scrollLeft = this.drag.left - (event.clientX - this.drag.x);
      });
      const endDrag = () => {
        if (!this.drag) return;
        const { track } = this.drag;
        this.drag = null;
        track.style.scrollSnapType = '';
        track.style.cursor = '';
        const index = this.indexOf(track);
        track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
      };
      root.addEventListener('mouseup', endDrag);
      root.addEventListener('mouseleave', endDrag);
    }

    pickOption(button) {
      const group = button.dataset.pdpOption;
      $$(`[data-pdp-option="${group}"]`, this.root).forEach((b) => b.setAttribute('aria-pressed', b === button ? 'true' : 'false'));
      this.render(true);
    }

    /* ---------- Karuzela ---------- */

    indexOf(track) {
      if (!track.clientWidth) return 0;
      const count = track.children.length;
      return Math.max(0, Math.min(count - 1, Math.round(track.scrollLeft / track.clientWidth)));
    }

    syncDots(track) {
      const gallery = track.closest('[data-gallery]');
      if (!gallery) return;
      const index = this.indexOf(track);
      $$('[data-gallery-dot]', gallery).forEach((dot) =>
        dot.classList.toggle('is-active', Number(dot.dataset.galleryDot) === index)
      );
    }

    goTo(index) {
      const gallery = this.gallery();
      const track = gallery && $('[data-gallery-track]', gallery);
      if (!track) return;
      track.scrollTo({ left: index * track.clientWidth, behavior: 'smooth' });
    }

    step(direction) {
      const gallery = this.gallery();
      const track = gallery && $('[data-gallery-track]', gallery);
      if (!track) return;
      const count = track.children.length;
      this.goTo((this.indexOf(track) + direction + count) % count);
    }

    /* ---------- Widok ---------- */

    render(userChange) {
      const selected = this.selection();
      const variant = this.variant();

      // Podpisy opcji
      selected.forEach((value, i) => {
        const label = $(`[data-pdp-option-label="${i + 1}"]`, this.root);
        if (label) label.textContent = value;
      });
      $$('[data-pdp-option]', this.root).forEach((button) =>
        button.classList.toggle('is-on', button.getAttribute('aria-pressed') === 'true')
      );

      // Karuzela dla wybranego koloru
      if (this.colorPos > 0) {
        const color = selected[this.colorPos - 1];
        const galleries = $$('[data-gallery]', this.root);
        const previous = this.gallery();
        galleries.forEach((g) => g.classList.toggle('is-hidden', g.dataset.color !== color));
        const next = this.gallery();
        if (next && next !== previous) {
          const track = $('[data-gallery-track]', next);
          if (track) track.scrollLeft = 0;
          $$('[data-gallery-dot]', next).forEach((dot, i) => dot.classList.toggle('is-active', i === 0));
        }
      }

      // Cena i identyfikator wariantu
      if (variant) {
        if (this.idInput) this.idInput.value = variant.id;
        if (this.priceEl) {
          this.priceEl.innerHTML = (variant.compare ? `<s>${variant.compare}</s> ` : '') + variant.price;
        }
        if (userChange && !this.noUrlUpdate) {
          const url = new URL(window.location.href);
          url.searchParams.set('variant', variant.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      // Mała torba do kompletu
      const addon = this.addonVariant();
      if (this.addonEl) {
        this.addonEl.hidden = !addon;
        if (!addon) this.addonOn = false;
        if (addon) {
          const color = this.colorPos > 0 && this.addonColorPos > 0 ? selected[this.colorPos - 1] : '';
          const sub = $('[data-pdp-addon-sub]', this.addonEl);
          if (sub) sub.textContent = `${color ? `${color} · ` : ''}+ ${addon.price}`;
          const thumb = $('[data-pdp-addon-thumb]', this.addonEl);
          if (thumb && addon.image) {
            if (thumb.getAttribute('src') !== addon.image) thumb.setAttribute('src', addon.image);
            thumb.hidden = false;
          }
        }
        this.addonEl.classList.toggle('is-on', this.addonOn);
        if (this.addonToggle) this.addonToggle.setAttribute('aria-checked', this.addonOn ? 'true' : 'false');
      }
      if (this.addonInput) this.addonInput.value = this.addonOn && addon ? addon.id : '';

      // Przycisk
      if (this.cta) {
        const d = this.root.dataset;
        let label = d.labelAdd;
        let disabled = false;
        if (!variant) {
          label = d.labelUnavailable;
          disabled = true;
        } else if (!variant.available) {
          label = d.labelSoldout;
          disabled = true;
        } else if (this.addonOn && addon) {
          label = d.labelSet.replace('__PRICE__', formatMoney(variant.cents + addon.cents));
        }
        this.cta.textContent = label;
        this.cta.disabled = disabled;
      }
    }
  }

  const init = () => {
    $$('[data-pdp]').forEach((root) => {
      if (root.__pdp) return;
      root.__pdp = new ProductView(root);
    });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
